import { render } from "./TextButton.vue?vue&type=template&id=d5172b20&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"

import "./TextButton.vue?vue&type=style&index=0&id=d5172b20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5172b20"]])

export default __exports__